import { apiFetch } from "#lib/api";
import { IShare } from "#entities/files";

export async function fetchProfileShares(
  service: string,
  creatorId: string,
  offset?: number
) {
  const path = `/${service}/user/${creatorId}/shares`;
  const params = new URLSearchParams();

  if (offset) {
    params.set("o", String(offset));
  }

  const result = await apiFetch<{ shares: IShare[], total: number }>(path, { method: "GET" }, params);

  return result;
}
